import { getConditionalObject } from 'utils/data';

export const getTabStyles = isDeleted => ({
  ...getConditionalObject(isDeleted, {
    pointerEvents: 'none',
    textDecoration: 'line-through',
    textDecorationThickness: '1px',
  }),
});

export const navigationTabLabelStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  position: 'relative',
  fontSize: 'inherit',
  lineHeight: 'inherit',
};
